interface Props {
  label: string;
  className?: string;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  disabled?: boolean;
  textClassName?: string;
  size?: "sm" | "md" | "lg";
}

export const PrimaryButton = ({
  label,
  className,
  onClick,
  disabled,
  textClassName,
  size = "sm",
  ...rest
}: Props) => {
  const buttonSize = {
    sm: "h-8 py-0",
    md: "py-2",
    lg: "py-4",
  };
  return (
    <button
      disabled={disabled}
      {...rest}
      onClick={onClick}
      className={`bg-droppie-oranje hover:opacity-90 border-droppie-oranje border  px-6 ${buttonSize[size]} rounded   disabled:bg-gray-100 disabled:border-gray-border disabled:cursor-not-allowed transition ease-linear ${className}`}
    >
      <p
        className={`font-satoshi font-medium ${
          disabled ? "text-sky-dark" : "text-white"
        } text-base ${textClassName}`}
      >
        {label}
      </p>
    </button>
  );
};
